import { getDashboardStatistics } from "@/shared/api/mutations/dashboard/dashboard";
import useFetchHook from "@/shared/hooks/useFetchHook";
import {
  DashboardStatisticsResponse,
  PayloadDashboardStatistics,
} from "@/shared/model/dashboard/dashboard";

export const useDashboard = (payload?: PayloadDashboardStatistics) => {
  const queryKey = [
    "DASHBOARD_STATISTICS",
    payload?.start_date ?? null,
    payload?.end_date ?? null,
  ];

  return useFetchHook<DashboardStatisticsResponse>({
    keys: queryKey,
    api: () => getDashboardStatistics(payload ?? {}),
    options: {
      meta: {
        errorMessage: "Failed to get Dashboard Statistics",
      },
      staleTime: 0,
      retry: 1,
    },
  });
};
